import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import NumberFieldEditor from './fields/NumberFieldEditor'
import SelectFieldEditor from './fields/SelectFieldEditor'
import JsonFieldEditor from './fields/JsonFieldEditor'
import BoolFieldEditor from './fields/BoolFieldEditor'
import TextFieldEditor from './fields/TextFieldEditor'
import HiddenFieldEditor from './fields/HiddenFieldEditor'
import ReadonlyDescriptionEditor from './fields/ReadonlyDescriptionEditor'
import ReadonlyAccessorEditor from './fields/ReadonlyAccessorEditor'
import AppContextFieldEditor from './fields/AppContextFieldEditor'
import MarkdownFieldEditor from './fields/MarkdownFieldEditor'
import DateFieldEditor from './fields/DateFieldEditor'
import DateTimeFieldEditor from './fields/DateTimeFieldEditor'
import TimeFieldEditor from './fields/TimeFieldEditor'

const EDITOR_TYPE_MAP = {
  number: NumberFieldEditor,
  select: SelectFieldEditor,
  json: JsonFieldEditor,
  bool: BoolFieldEditor,
  text: TextFieldEditor,
  textarea: TextFieldEditor,
  hidden: HiddenFieldEditor,
  'readonly-description': ReadonlyDescriptionEditor,
  'readonly-accessor': ReadonlyAccessorEditor,
  appcontext: AppContextFieldEditor,
  markdown: MarkdownFieldEditor,
  date: DateFieldEditor,
  datetime: DateTimeFieldEditor,
  time: TimeFieldEditor
}

function DynamicFieldRenderer ({ field, control, form, initializationData }) {
  const EditorComponent = EDITOR_TYPE_MAP[field.editorType] || TextFieldEditor

  // Readonly and hidden fields don't need Grid wrapping
  const isReadonly = ['readonly-description', 'readonly-accessor'].includes(field.editorType)
  const isHidden = ['hidden', 'appcontext'].includes(field.editorType)

  if (isReadonly) {
    return (
      <Grid item xs={12}>
        <EditorComponent
          field={field}
          initializationData={initializationData}
        />
      </Grid>
    )
  }

  if (isHidden) {
    return (
      <EditorComponent
        field={field}
        control={control}
        form={form}
      />
    )
  }

  // Get Grid sizing from display.size or use defaults
  const gridXs = field.display?.size?.xs || 12
  const gridSm = field.display?.size?.sm
  const gridMd = field.display?.size?.md
  const gridLg = field.display?.size?.lg

  return (
    <Grid item xs={gridXs} sm={gridSm} md={gridMd} lg={gridLg}>
      <EditorComponent
        field={field}
        control={control}
        form={form}
        initializationData={initializationData}
      />
    </Grid>
  )
}

DynamicFieldRenderer.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    editorType: PropTypes.string.isRequired,
    display: PropTypes.shape({
      size: PropTypes.shape({
        xs: PropTypes.number,
        sm: PropTypes.number,
        md: PropTypes.number,
        lg: PropTypes.number
      })
    })
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  initializationData: PropTypes.any
}

export default DynamicFieldRenderer
